var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"previewList"},[_c('h3',{staticClass:"previewList__title"},[_vm._v(_vm._s(_vm.title)+" :")]),_vm._t("default",function(){return [(_vm.isShow(_vm.content))?_c('div',[_vm._t("extra-start"),_c('p',[_vm._v(_vm._s(_vm.prefix)+_vm._s(_vm.content))]),_vm._t("extra")],2):_c('p',[_vm._v("Nil")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }